import React from "react";
import { Brush, CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { getLineColor } from "../../../utils/getLineColor";

function transformChartData(rawData, lines) {
    const transformed = [];

    rawData.forEach((item) => {
        const key = lines?.find((line) => line.id === item.lineId)?.label  || `${item?.name} - ${item?.values?.join(", ")}`;

        let existing = transformed.find((d) => d.label === item.label);
        if (!existing) {
            existing = { label: item?.label };
            transformed.push(existing);
        }

        existing[key] = parseFloat(item?.average);
    });

    return transformed;
}

const ScoreBreakdownOverTimeChart = ({ chartData, widget, smoothLine, lines }) => {
    const transformedData = transformChartData(chartData, lines);

    const lineKeys = Object.keys(transformedData[0] || {}).filter(
        (key) => key !== "label"
    );
    const rawValues = transformedData.flatMap((dataPoint) =>
        lineKeys.map((key) => dataPoint[key])
    );
    const rawMin = Math.min(...rawValues);
    const rawMax = Math.max(...rawValues);

    const minScore = Math.floor(rawMin );
    const maxScore = Math.ceil(rawMax );
    return (
        <div style={{ height: widget.layout.h * 39 - 80 }} onMouseDown={(e) => {
            if (e.target.closest(".recharts-brush")) {
                e.stopPropagation();
                e.preventDefault()
            }
        }}>
            <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    data={transformedData}
                    margin={{
                        top: 10,
                        right: 30,
                        left: 0,
                        bottom: 0,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                        dataKey="label"
                        tick={{ fontSize: 16, fill: "#333", fontWeight: "500" }}
                        label={{
                            position: "insideBottom",
                            dy: 20,
                            fontSize: 16,
                            fill: "#555",
                        }}
                        interval="preserveStartEnd"
                    />
                    <YAxis
                        label={{
                            value: `Percentage (%)`,
                            angle: -90,
                            position: "insideLeft",
                            offset: 20,
                            style: {
                                textAnchor: "middle",
                                fontSize: `16px`,
                                fontWeight: "bold",
                                color: "#000",
                            },
                        }}
                        tick={{ fontSize: 16, fill: "#333" }}
                        domain={[minScore, maxScore]}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: "#f5f5f5",
                            borderRadius: "10px",
                        }}
                        labelStyle={{ fontWeight: "bold" }}
                        formatter={(value) => `${value}%`}
                    />
                    <Legend
                        align="center"
                        verticalAlign="bottom"
                        wrapperStyle={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            marginTop: "20px",
                        }}
                    />
                    <Brush
                        dataKey="date"
                        height={30}
                        stroke="#696969"
                        travellerWidth={12}
                        gap={2}
                        startIndex={0}
                        endIndex={chartData.length - 1}
                        fill="#D3D3D3"
                        travellerStyle={{
                            stroke: "#696969",
                            fill: "#A9A9A9",
                            cursor: "pointer",
                        }}
                        selectedBoxStyle={{
                            stroke: "#A9A9A9",
                            fill: "rgba(169, 169, 169, 0.2)",
                            cursor: "move",
                        }}
                        padding={{ top: 2, bottom: 2 }}
                    />
                    {lineKeys.map((key, index) => (
                        <Line
                            key={key}
                            type={smoothLine ? "monotone" : "linear"}
                            dataKey={key}
                            stroke={getLineColor(index)}
                            strokeWidth={3}
                            dot={false}
                            activeDot={{
                                r: 6,
                                stroke: getLineColor(index),
                                strokeWidth: 2,
                            }}
                            name={key}
                        />
                    ))}
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default ScoreBreakdownOverTimeChart;
